/** An empty Home (SA-475, Home spec §13 FF4): one quiet line where the grid
 * would be. With widgets to add back, the button opens Customize, where the
 * Add list sits; with none, the header's Customize is all there is. */
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui'

export function HomeEmpty({ canAdd, onAdd }: { canAdd: boolean; onAdd: () => void }) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-dashed border-border px-4 py-3.5 text-[13px] text-muted-foreground">
      <span>{canAdd ? 'Nothing is on your Home page.' : 'Nothing on Home is available to you yet.'}</span>
      {canAdd && (
        <Button variant="outline" size="sm" className="ml-auto" onClick={onAdd}>
          <Plus className="size-4" /> Add a widget
        </Button>
      )}
    </div>
  )
}
